import { render } from "./Stammdaten.vue?vue&type=template&id=28140a60"
import script from "./Stammdaten.vue?vue&type=script&lang=js"
export * from "./Stammdaten.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__